import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
import ScrollToTop from './ScrollToTop';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import About from './components/About';
import Infrastructure from './components/Infrastructure';
import { Facilities } from './components/Facilities';
import  Gallery  from './components/Gallery';
import Contact from './components/Contact';
import Admission from './components/Admission';
import { useEffect } from 'react';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminHeroBanners from './admin/pages/home/AdminHeroBanners';
import AdminAchievementMaster from './admin/pages/achievements/AdminAchievementCategoryMaster';
import AdminFacultyList from './admin/pages/faculty/AdminFacultyList';
import AdminGalleryPhotos from './admin/pages/gallery/AdminGalleryPhotos';
import AdminGalleryCategories from './admin/pages/gallery/AdminGalleryCategories';
import AdminInfraCategories from './admin/pages/infrastructure/AdminInfraCategories';
import AdminInfraItems from './admin/pages/infrastructure/AdminInfraItems';
import AdminCustomAlumni from './admin/pages/alumni/AdminCustomAlumni';
import AdminContactEnquiries from './admin/pages/enquiries/AdminContactEnquiries';


function App() {

  const { pathname, hash, key } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");

  useEffect(() => { 
    if (hash === '') {
      window.scrollTo(0, 0);
    } 
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]);  
  return (
    <div className="App">
      <ScrollToTop/>
      {!isAdminRoute ? <Navbar/> : null}
      <div className={isAdminRoute ? "AllPage AllPage--admin" : "AllPage"}> 
        <Routes>
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminLayout />}>
              <Route index element={<Navigate to="home/hero-banners" replace />} />
              <Route path="home/hero-banners" element={<AdminHeroBanners />} />
              <Route path="achievements/master" element={<AdminAchievementMaster />} />
              <Route path="achievements/school" element={<Navigate to="/admin/dashboard/achievements/master" replace />} />
              <Route path="achievements/categories" element={<Navigate to="/admin/dashboard/achievements/master" replace />} />
              <Route path="achievements" element={<Navigate to="achievements/master" replace />} />
              <Route path="home/achievements" element={<Navigate to="achievements/master" replace />} />
              <Route path="faculty/list" element={<AdminFacultyList />} />
              <Route path="gallery/photos" element={<AdminGalleryPhotos />} />
              <Route path="gallery/categories" element={<AdminGalleryCategories />} />
              <Route path="infrastructure/categories" element={<AdminInfraCategories />} />
              <Route path="infrastructure/items" element={<AdminInfraItems />} />
              <Route path="alumni/custom" element={<AdminCustomAlumni />} />
              <Route path="enquiries/contact" element={<AdminContactEnquiries />} />
              <Route path="*" element={<Navigate to="home/hero-banners" replace />} />
            </Route>

            <Route path="/"  element={<Home/>}/> 
            <Route path="/about"  element={<About/>}/> 
            <Route path="/infrastructure"  element={<Infrastructure/>}/>  
            <Route path="/faculty"  element={<Facilities/>}/>
            <Route path="/activities"  element={<Gallery/>}/>  
            <Route path="/contacts"  element={<Contact/>}/>  
            <Route path="/admission"  element={<Admission/>}/> 
        </Routes>
      </div>
      {!isAdminRoute ? <Footer/> : null}
    </div>
  );
}

export default App;
